import React from "react";
import { useStore } from "../../store";
import PropTypes from "prop-types";
import { Type } from "@ebscois/react-component-library";

import {
  StyledAcpLogo,
  StyledWrapper,
  StyledLabel,
  StyledHeading,
} from "./_styled";

const AboutTabContributorRow = ({ data }) => {
  const { contributorLogos } = useStore();
  return data.acpContributor ? (
    <StyledAcpLogo
      data-testid="contributor-acp"
      src={contributorLogos?.acp.src}
      alt={contributorLogos?.acp.alt}
    />
  ) : (
    <StyledWrapper data-testid="contributor-row">
      <StyledLabel
        element="h6"
        data-testid="contributor-label"
        fontWeight="semibold"
        textTransform="uppercase"
        color="secondary"
      >
        {data.label}
      </StyledLabel>
      <Type fontSize="lg" data-testid="contributor-name">
        {`${data.givenName} ${data.surname} ${data.degrees}`}
      </Type>
      <StyledHeading element="h6" fontWeight="semibold">
        Affiliations
      </StyledHeading>
      <Type element="p" fontSize="sm" data-testid="contributor-affiliation">
        {data.affiliationText}
      </Type>
      {data.conflictsText && (
        <React.Fragment>
          <StyledHeading>Conflicts of Interest</StyledHeading>
          <Type element="p" fontSize="sm" data-testid="contributor-conflicts">
            {data.conflictsText}
          </Type>
        </React.Fragment>
      )}
    </StyledWrapper>
  );
};

AboutTabContributorRow.propTypes = {
  label: PropTypes.element,
};

AboutTabContributorRow.displayName = "AboutTabContributorRow";
export default AboutTabContributorRow;
